import { BASE_URI } from '@/shared/config';

export const getStudyArchiveURL = (studyID: string): string =>
  `${BASE_URI}/api/storage/download/study_archive/${studyID}`;
